import Box from "@mui/material/Box";
import WizardStep from "../../../../components/Wizard/WizardStep"
import useICPWizard from "../hooks/useICPWizard";
import { ReactNode, useMemo, useState } from "react";
import Typography from "@mui/material/Typography";
import { IdealCustomerProfileListItem, Sprint } from "../../../../stores/SprintStore";
import { Alert, Avatar, AvatarGroup, Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RenderIf, { ClaimType, ClaimValue } from "../../../common/RenderIf";
import DeleteIcon from '@mui/icons-material/Delete';
import DateTimeDisplay from "../../../common/DateTimeDisplay";
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from "../../../common/ConfirmationDialog";

type Props = {
    onCancel: () => void,
    steps?: ReactNode
}

const ICPSelect = ({ onCancel, steps }: Props) => {
    const { errors, handleNextStep, sprint, icp, onICPChange,deleteIcp, loadIcp, createIcp } = useICPWizard();
    const [showError, setShowError] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedIcpId, setSelectedIcpId] = useState('');

    const handleNext = async () => {
        setShowError(false);

        try {
            createIcp(sprint);
            handleNextStep();
        } catch (err) {
            setShowError(true);
        }
    }

    const confirmDelete = (id: string) => {        
        setSelectedIcpId(id);
        setDeleteOpen(true);
    }

    const cancelDelete = () => {
        setSelectedIcpId('');
        setDeleteOpen(false);
    }

    const handleDelete = async () => {
        await deleteIcp(selectedIcpId);        

        setSelectedIcpId('');
        setDeleteOpen(false);
    }

    const renderCard = (item: IdealCustomerProfileListItem) => {
        return (
            <Grid item xs={12} sm={6} lg={4}>
                <Card variant='outlined'>
                    <CardContent>
                        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant='body2'>{item.cadenceName}</Typography>
                            <AvatarGroup
                                max={4}
                                sx={{
                                    '& .MuiAvatarGroup-avatar': { fontSize: '.875rem' },
                                    '& .MuiAvatar-root, & .MuiAvatarGroup-avatar': { width: 32, height: 32 }
                                }}
                            >
                                {/*{item.avatars.map((img, index: number) => (*/}
                                {/*    <Avatar key={index} alt={item.name} src={img} />*/}
                                {/*))}*/}

                            </AvatarGroup>
                            <Typography variant='body2'> <DateTimeDisplay value={icp.cadenceStartDate} format='date' /></Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant='h6'>{item.name}</Typography>
                            {/*{item.name.toUpperCase() !== "ADMIN" && item.name.toUpperCase() !== "PENDING (NO ACCESS)" &&*/}
                            {/*    <IconButton simze="small" title="Rename Group"><EditIcon fontSize='small' /></IconButton>*/}
                            {/*}*/}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Delete}>
                                <IconButton title="Edit & Assign Leads" size='small' sx={{ color: 'text.primary' }} onClick={() => { loadIcp(item.id) }} >
                                    <EditIcon fontSize='small' />
                                </IconButton>
                            </RenderIf>

                            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Delete}>
                                {item.name.toUpperCase() !== "ADMIN" && item.name.toUpperCase() !== "PENDING (NO ACCESS)" && <IconButton title="Delete ICP" size='small' sx={{ color: 'text.primary' }} onClick={() => confirmDelete(item.id)}>
                                    <DeleteIcon fontSize='small' />
                                </IconButton>}
                            </RenderIf>

                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        )
    }

    return (
        <WizardStep
            title="ICP Builder - Select Ideal Customer Profile"
            subtitle="Ideal Customer Profile"
            onClose={onCancel}

        >
            <Box display='flex' sx={{ height: '100%' }}>
                {steps}
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', rowGap: 4, width: '100%' }}>
                    <Grid container spacing={6} className='match-height'>
                        <Grid item xs={12} sm={6} lg={4}>
                            <Card variant='outlined'>
                                <Grid container sx={{ height: '100%' }}>
                                    <Grid item xs={5}>
                                        <Box sx={{ height: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                                            <img width={65} height={130} alt='add-role' src='/images/cards/pose_m1.png' />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <CardContent>
                                            <RenderIf claimType={ClaimType.Sprints} claimValue={ClaimValue.AssignLeads}>
                                                <Box sx={{ textAlign: 'right' }}>
                                                    <Button
                                                        size="small"
                                                        variant='contained'
                                                        sx={{ mb: 3, whiteSpace: 'nowrap' }}
                                                        onClick={() => {
                                                            handleNext();
                                                        }}
                                                        endIcon={<AddIcon />}
                                                    >
                                                        Add New ICP
                                                    </Button>
                                                    <Typography>Add ICP, if it doesn't exist.</Typography>
                                                </Box>
                                            </RenderIf>

                                        </CardContent>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>

                        {sprint.idealCustomerProfiles.map(item => renderCard(item))}
                    </Grid>
                </Box>
            </Box>
            <ConfirmationDialog
                open={deleteOpen}
                onCancel={cancelDelete}
                onConfirm={handleDelete}
                message="Are you sure you want to delete the ideal customer profile?" title="Confirm Delete"
                cancelButtonText='Cancel'
                confirmButtonText='Delete'
            />
        </WizardStep>
    )
}

export default ICPSelect;